import Vue from 'vue'
import Vuex from 'vuex'
import Common from './api/common'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		User: {
			name: '',
			desc: '',
			email: '',
			org: '',
			dept: '',
			title: '',
			location: '',
			avatar: '/images/avatar.png',
			tags: ['善解人意', '耿直']
		},
		currentAccountSets: {},
		myAccountSets: [],
		partnerAccountSetsList:[],
		communityAccountSetsList:[],
		defaultAccountSetsList:[],
		storeAccountSetsList:[],
		sliderCollapsed: false
	},
	mutations: {
		updateAccount(state, data) {
			state.User = data;
			state.currentAccountSets = data.accountSets;
			state.myAccountSets = data.accountSetsList;
			//2024-04-09新增
			if(data.accountSetsList.length > 0){
				var partnerAccountSetsList=new Array();
				var communityAccountSetsList=new Array();
				var defaultAccountSetsList=new Array();
				var storeAccountSetsList=new Array();
				data.accountSetsList.forEach(item => {
					if(item.accountType==1){
						partnerAccountSetsList.push(item);
					}else if(item.accountType==2){
						communityAccountSetsList.push(item);
					}
					else if(item.accountType==3){
						defaultAccountSetsList.push(item);
					}
					else if(item.accountType==4){
						storeAccountSetsList.push(item);
					}
				});
				state.partnerAccountSetsList = partnerAccountSetsList;
				state.communityAccountSetsList = communityAccountSetsList;
				state.defaultAccountSetsList = defaultAccountSetsList;
				state.storeAccountSetsList = storeAccountSetsList;
			}
		},
		updateSliderCollapse(state, isShow) {
			setTimeout(() => {
				G.trigger('page_resize');
			}, 600);
			state.sliderCollapsed = isShow;
		}
	},
	actions: {
		init(context) {
			return new Promise((resolve, reject) => {
				Common.init().then(({ data }) => {
					context.commit('updateAccount', data);

					console.log('data', data);

					resolve(data)

				}).catch(() => {
					reject();
				})
			});
		}
	},
	getters: {
		account: state => {
			return state.User;
		},
		sliderCollapsed: state => {
			return state.sliderCollapsed;
		}
	}
})
